import cancelApiCall from './cancel';
import createApi from './create';
import detailApiCall from './detail';
import editApiCall from './edit';
import forceCancelApiCall from './force-cancel';
import listApiCall from './list';
import statusHistoriesApiCall from './status-histories';
import syncApiCall from './sync';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  create: createApi,
  edit: editApiCall,
  delete: editApiCall,
  sync: syncApiCall,
  cancel: cancelApiCall,
  forceCancel: forceCancelApiCall,
  statusHistories: statusHistoriesApiCall,
};

export default ApiCall;
